export default "__VITE_ASSET__B5f17dUH__"